import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import MsingiPoaTabs from "./MsingiPoaTabs";
import BoreshaTabs from "./BoreshaTabs";
import { FiArrowDownCircle } from 'react-icons/fi'
import CriticalApply from '../../assets/CriticalApply.pdf'
import CriticalClaim from '../../assets/CriticalClaim.pdf'

export default function Boresha() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">
              Boresha Elimu Education Plan
            </h3>
            <p className="mt-6 text-base max-w-lg leading-7 ">
              This is a simple and affordable education savings plan, which
              secures the future for your child. It provides flexible pay-outs
              at important stages of your child's education, perfectly aligned
              with the new education curriculum 2-6-3-3-3.{" "}
            </p>
            <div className="my-4">
      <ul className="list-disc list-inside">
      <li>High savings returns.</li>
      <li>lower policy terms (minimum 6 years)</li>
      <li>Simple product design.</li>
      <li>High entry ages up to age 60</li>
      <li>No premium remittances/payment for the last two years of policy.</li>
      <li>Optional Lump Sum Death Cover at affordable rates.</li>

        </ul>
        </div>

            <div className="mt-10 flex items-center gap-x-4">
            <div className="flex gap-x-4 items-center  ">
              <a
                download={CriticalApply}
                href={CriticalApply}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Application Form
                </span>
              </a>
              <a
                href={CriticalClaim}
                download={CriticalClaim}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Claim Form
                </span>
              </a>
           
            </div>
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-3xl pt-24 lg:flex-shrink-0">
            <BoreshaTabs />
          </div>
        </div>
      </div>
    </div>
  );
}
